import { useEffect, useState } from 'react'
import { FOOD_SAFETY_POLL_INTERVAL_MS } from 'src/hooks/useFoodSafetyTodayBadgeCount'
import {
  fetchVenueHome,
  VENUE_HOME_CHANGED_EVENT,
  venueHomeIsClearDay,
  venueHomeOutstandingCount,
} from 'src/utils/venueHomeApi'

/**
 * Outstanding Home tasks for the top-nav badge.
 * Same quiet poll and focus refresh as Food Safety. A failed load does not
 * clear a count we already showed.
 */
const useVenueHomeOutstandingCount = venueId => {
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!venueId) {
      setCount(0)
      return undefined
    }

    let cancelled = false
    setCount(0)

    const load = () => {
      fetchVenueHome({ venueId })
        .then(home => {
          if (cancelled) return null
          if (home && String(home.venueId || '') !== String(venueId))
            return null
          setCount(
            venueHomeIsClearDay(home) ? 0 : venueHomeOutstandingCount(home),
          )
          return null
        })
        .catch(error => {
          console.error('useVenueHomeOutstandingCount poll failed', error)
          return null
        })
    }

    load()
    const interval = setInterval(load, FOOD_SAFETY_POLL_INTERVAL_MS)
    const onFocus = () => load()
    window.addEventListener('focus', onFocus)
    window.addEventListener(VENUE_HOME_CHANGED_EVENT, load)

    return () => {
      cancelled = true
      clearInterval(interval)
      window.removeEventListener('focus', onFocus)
      window.removeEventListener(VENUE_HOME_CHANGED_EVENT, load)
    }
  }, [venueId])

  return count
}

export default useVenueHomeOutstandingCount
